var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var _a;
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { RadioButtons, TextBox, useModal, } from "@animech/ui";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { LoadingModal } from "../../loading-modal/loading-modal";
import * as Styled from "./save-system-modal.style";
import { usePlaycanvasApplicationContext } from "providers/playcanvas-application";
import { CustomConfirmModal } from "ui/components/modals/custom-confirm-modal/custom-confirm-modal";
import { useAppSelector, selectors, actions, useAppDispatch } from "store";
import { persistConfigs } from "store/persist";
import { SaveSystemConfirmationModal } from "ui/components/modals/ovm-backend/save-system-modal/save-system-confirmation-modal";
import { createFolderTree, flattenFolderTree } from "store/user/util";
import { Dropdown } from "ui/components/elements/input/dropdown";
var SaveMode;
(function (SaveMode) {
    SaveMode["SAVE"] = "save";
    SaveMode["COPY"] = "copy";
})(SaveMode || (SaveMode = {}));
var translationPrefix = "save_system_modal";
var content = (_a = {},
    _a[SaveMode.SAVE] = {
        label: "".concat(translationPrefix, ".radio_button_save"),
        okActionLabel: "".concat(translationPrefix, ".confirm_button_save"),
        icon: "save",
    },
    _a[SaveMode.COPY] = {
        label: "".concat(translationPrefix, ".radio_button_save_copy"),
        okActionLabel: "".concat(translationPrefix, ".confirm_button_save_copy"),
        icon: "copy",
    },
    _a);
var items = Object.keys(content).map(function (item) { return item; });
var itemLabels = Object.values(content).map(function (item) { return item.label; });
var icons = Object.values(content).map(function (item) { return item.icon; });
var ROOT_FOLDER_ID = "__root__";
export var SaveSystemStateModal = function (_a) {
    var props = __rest(_a, []);
    var onShouldClose = props.onShouldClose;
    var t = useTranslation().t;
    var openModal = useModal();
    var generateScreenshot = usePlaycanvasApplicationContext().generateScreenshot;
    var activeSystem = useAppSelector(selectors.selectUserActiveSystem);
    var folders = useAppSelector(selectors.selectUserRoot).folders;
    var activeFolderId = useAppSelector(selectors.selectActiveFolderId);
    var dispatch = useAppDispatch();
    var _b = __read(useState((activeSystem === null || activeSystem === void 0 ? void 0 : activeSystem.name) || ""), 2), systemName = _b[0], setSystemName = _b[1];
    var _c = __read(useState(SaveMode.COPY), 2), saveMode = _c[0], setSaveMode = _c[1];
    var _d = __read(useState((activeSystem === null || activeSystem === void 0 ? void 0 : activeSystem.folderId) || activeFolderId || ROOT_FOLDER_ID), 2), selectedFolderId = _d[0], setSelectedFolderId = _d[1];
    var flatFolders = useMemo(function () {
        var tree = createFolderTree(folders, t("home-menu.saved-systems.root-folder"));
        return flattenFolderTree(tree);
    }, [folders, t]);
    var folderItems = useMemo(function () { return flatFolders.map(function (f) { var _a; return (_a = f.id) !== null && _a !== void 0 ? _a : ROOT_FOLDER_ID; }); }, [flatFolders]);
    var folderLabels = useMemo(function () {
        return flatFolders.map(function (f) {
            var indent = "\u00A0".repeat(f.depth * 5);
            return "".concat(indent).concat(f.depth > 0 ? "└ " : "").concat(f.label);
        });
    }, [flatFolders]);
    var selectedFolderLabels = useMemo(function () { return flatFolders.map(function (f) { return f.label; }); }, [flatFolders]);
    var showFolderPicker = saveMode === SaveMode.COPY || !(activeSystem === null || activeSystem === void 0 ? void 0 : activeSystem.id);
    useEffect(function () {
        if (folders.length === 0) {
            dispatch(actions.getUserSystems());
        }
    }, [dispatch, folders.length]);
    useEffect(function () {
        if (!(activeSystem === null || activeSystem === void 0 ? void 0 : activeSystem.id)) {
            setSaveMode(SaveMode.COPY);
            return;
        }
        setSaveMode(SaveMode.SAVE);
    }, [activeSystem === null || activeSystem === void 0 ? void 0 : activeSystem.id]);
    var onSaveSystem = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var performSaveRequest, onConfirmSave;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    performSaveRequest = function () { return __awaiter(void 0, void 0, void 0, function () {
                        var loadingModal, dataToSave, persistConfigs_1, persistConfigs_1_1, config, storedSlice, shouldOverwriteSystem, folderId, e_1;
                        var e_2, _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    loadingModal = openModal(_jsx(LoadingModal, { translationKey: "save_system_modal.loading_save" }));
                                    dataToSave = [];
                                    try {
                                        for (persistConfigs_1 = __values(persistConfigs), persistConfigs_1_1 = persistConfigs_1.next(); !persistConfigs_1_1.done; persistConfigs_1_1 = persistConfigs_1.next()) {
                                            config = persistConfigs_1_1.value;
                                            storedSlice = window.sessionStorage.getItem("persist:".concat(config.key));
                                            storedSlice &&
                                                dataToSave.push({ persistKey: config.key, data: storedSlice });
                                        }
                                    }
                                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                                    finally {
                                        try {
                                            if (persistConfigs_1_1 && !persistConfigs_1_1.done && (_a = persistConfigs_1.return)) _a.call(persistConfigs_1);
                                        }
                                        finally { if (e_2) throw e_2.error; }
                                    }
                                    shouldOverwriteSystem = saveMode === SaveMode.SAVE && (activeSystem === null || activeSystem === void 0 ? void 0 : activeSystem.id);
                                    _b.label = 1;
                                case 1:
                                    _b.trys.push([1, 6, , 7]);
                                    if (!shouldOverwriteSystem) return [3 /*break*/, 3];
                                    return [4 /*yield*/, dispatch(actions.saveSystem(__assign(__assign({}, activeSystem), { name: systemName, imageSrc: generateScreenshot(135, 135), persistParts: dataToSave }))).unwrap()];
                                case 2:
                                    _b.sent();
                                    return [3 /*break*/, 5];
                                case 3:
                                    folderId = selectedFolderId === ROOT_FOLDER_ID ? null : selectedFolderId;
                                    return [4 /*yield*/, dispatch(actions.createSystem({
                                            name: systemName,
                                            imageSrc: generateScreenshot(135, 135),
                                            persistParts: dataToSave,
                                            folderId: folderId,
                                        })).unwrap()];
                                case 4:
                                    _b.sent();
                                    _b.label = 5;
                                case 5:
                                    loadingModal.close();
                                    onShouldClose && onShouldClose(true);
                                    return [3 /*break*/, 7];
                                case 6:
                                    e_1 = _b.sent();
                                    loadingModal.close();
                                    return [3 /*break*/, 7];
                                case 7: return [2 /*return*/];
                            }
                        });
                    }); };
                    if (!(saveMode === SaveMode.SAVE)) return [3 /*break*/, 2];
                    return [4 /*yield*/, openModal(_jsx(SaveSystemConfirmationModal, { systemName: (_a = activeSystem === null || activeSystem === void 0 ? void 0 : activeSystem.name) !== null && _a !== void 0 ? _a : "" })).done()];
                case 1:
                    onConfirmSave = _b.sent();
                    if (onConfirmSave) {
                        performSaveRequest();
                    }
                    return [3 /*break*/, 3];
                case 2:
                    performSaveRequest();
                    _b.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); }, [
        activeSystem,
        dispatch,
        generateScreenshot,
        onShouldClose,
        openModal,
        saveMode,
        selectedFolderId,
        systemName,
    ]);
    var text = content[saveMode];
    return (_jsx(CustomConfirmModal, __assign({ title: t("".concat(translationPrefix, ".title")), cancelActionLabel: t("modal.close"), okActionLabel: t(text.okActionLabel), color: "inverted", cancelButtonProps: { color: "primary" }, confirmButtonProps: {
            color: "primary",
            onClick: function () { return onSaveSystem(); },
            disabled: systemName === "",
        }, hideCloseButton: false }, props, { children: _jsxs(Styled.Container, { children: [_jsx(RadioButtons, { items: items, itemLabels: itemLabels.map(function (label) { return t(label); }), value: saveMode, color: "inverted", onValueChange: setSaveMode, itemIcons: icons, disabled: !activeSystem }), _jsxs(Styled.TextFieldContainer, { children: [_jsx("span", { children: t("".concat(translationPrefix, ".textbox_label")) }), _jsx(TextBox, { maxLength: 20, value: systemName, onValueChange: setSystemName, instantValueChange: true })] }), showFolderPicker && (_jsx(Dropdown, { items: folderItems, itemLabels: folderLabels, selectedItemLabels: selectedFolderLabels, value: selectedFolderId, onValueChange: setSelectedFolderId, label: t("".concat(translationPrefix, ".folder_label")) }))] }) })));
};
